import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import { Notify,Lazyload } from 'vant';
Vue.config.productionTip = false;
import 'vant/lib/index.css';
Vue.use(Vant)
Vue.use(Notify)
Vue.use(Lazyload)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
